import React from 'react';
import {Typography} from 'epic-ue-ui';
import styled from 'styled-components';

const Styled = styled.div`
    display: none;
    padding: 10px;
    border-bottom: 1px solid #303034;

    ${(p) => p.theme.breakpoints.down('sm')} {
        display: block;
        .filterHeading {
            display: inline;
            font-size: 22px;
            line-height: 30px;
            font-weight: 400;
        }
        svg {
            float: right;
            margin-top: 7px;
            cursor: pointer;
            path {
                fill: #aaaaae;
            }
        }
    }
`;

interface Props {
    setOpenedFilterBarMobile: (b: boolean) => void;
    filterLabel?: string;
}

export const MobileFilterHeading = ({
    setOpenedFilterBarMobile,
    filterLabel
}: Props): JSX.Element => {
    return (
        <Styled className="filterHeadingSection">
            <Typography className="filterHeading" variant="h3">
                {filterLabel || 'Filter'}
            </Typography>
            <svg
                onClick={() => {
                    setOpenedFilterBarMobile(false);
                }}
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 11.4142L17.7782 19.1924L19.1924 17.7782L11.4142 10L19.1924 2.22185L17.7782 0.807635L10 8.5858L2.22183 0.807617L0.807617 2.22183L8.5858 10L0.807617 17.7782L2.22183 19.1924L10 11.4142Z"
                    fill="black"
                />
            </svg>
        </Styled>
    );
};
